import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const DayTitleSectionLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder width={130} height='100%' />
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20px;
    margin-bottom: 5px;
`;